// @flow

import type {
  MarkdocNodeRegistration,
  MarkdocFragmentRegistration,
} from 'docs/markdoc';
import {isMarkdocAstTag} from 'docs/util';

export const Table: MarkdocFragmentRegistration = {
  tag: 'table',
  attributes: {
    type: {type: String, default: 'striped'},
    fixed: {type: Boolean, default: false},
    highlightCol: {type: Number},
  },
  render(node, config) {
    const child = node.children[0];

    if (child?.type !== 'table') {
      return [];
    }

    const table = child.render(config);

    if (!Array.isArray(table) && isMarkdocAstTag(table)) {
      table.attributes = node.renderAttributes(this.attributes, config);
    }

    return table;
  },
};

export const TableNode: MarkdocNodeRegistration = {
  node: 'table',
  component: 'Table',
  attributes: {
    type: {
      type: String,
      default: 'striped',
      description: "Can be 'solid', 'striped', or 'reference'. ",
    },
    fixed: {
      type: Boolean,
      default: false,
      description:
        'Determines whether the table is rendered with fixed layout.',
    },
    highlightCol: {
      type: Number,
      description: 'Highlight one column in the table, range from 1 to n.',
    },
  },
};

export const Th: MarkdocNodeRegistration = {
  node: 'th',
  component: 'TableHeaderCell',
  attributes: {
    colspan: {type: Number},
    width: {type: Number},
    align: {type: String},
  },
};

export const Td: MarkdocNodeRegistration = {
  node: 'td',
  component: 'TableCell',
  attributes: {
    colspan: {type: Number},
    rowspan: {type: Number},
    align: {type: String},
  },
};
